<template>
  <div class="reportselectorcontainer">
    <el-popover placement="bottom" title="" width="230" trigger="click">
      <div class="container-report-type-selector">
        <div class="container-checks">
          <el-checkbox-group v-model="selectedReports">
            <span v-for="(reportOption, index) in reportOptions" :key="index">
              <el-checkbox v-if="checkCountryVisibility(reportOption.label.countrys_oculto)" :label="reportOption.label" class="row-check checkbox-reverse">{{
                $t(reportOption.literal)
              }}</el-checkbox>
            </span>
          </el-checkbox-group>
        </div>
      </div>

      <el-button slot="reference" class="btn-primary-brains btn-input-type-brains"> {{ $t('report') }} <i class="el-icon-arrow-down icon-btn-dropdown" aria-hidden="true" /> </el-button>
    </el-popover>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ReportTypeSelector',
  components: {},
  data() {
    return {
      selectedReports: []
    }
  },
  computed: {
    ...mapState('location', {
      geolevelselected: (state) => state.geolevelselected,
      geolevels: (state) => state.geolevels
    }),
    reportOptions() {
      return [
        {
          label: {
            id: 'liquidity',
            report_name: 'report_name_liquidity',
            map_id: 'Trans_Vs_BuildStock_resi',
            map_name: 'num-transactions-vs-built-stock',
            map_source: '',
            charts: [],
            chart_source: '',
            countrys_oculto: [],
            nivelMax: 9,
            template: 'estandarTemplate'
          },
          literal: 'liquidity'
        },
        {
          label: {
            id: 'sales_price',
            report_name: 'report_name_sales_price',
            map_id: 'Asking_Var_YoY_Em2_resi',
            map_name: 'dataSelectors.asking-prices-growth-yoy',
            map_source: '',
            charts: [],
            chart_source: '',
            countrys_oculto: [],
            nivelMax: 9,
            template: 'estandarTemplate'
          },
          literal: 'sale-prices'
        },
        {
          label: {
            id: 'rental_prices',
            report_name: 'report_name_rental_prices',
            map_id: 'Asking_rent_Var_YoY_Em2_resi',
            map_name: 'dataSelectors.asking-prices-growth-yoy',
            map_source: '',
            charts: [],
            chart_source: 'Brainsre',
            countrys_oculto: [],
            nivelMax: 9,
            template: 'estandarTemplate'
          },
          literal: 'rent-prices'
        },
        {
          label: {
            id: 'sale_top25municipalities',
            report_name: 'sale_top25municipalities_name',
            map_id: null,
            map_name: null,
            map_source: '',
            charts: [],
            chart_source: '',
            countrys_oculto: [],
            nivelMax: 9,
            template: 'benchmarksTemplate'
          },
          literal: 'sale-top-25-municipalities'
        },
        {
          label: {
            id: 'rent_top25municipalities',
            report_name: 'rent_top25municipalities_name',
            map_id: null,
            map_name: null,
            map_source: '',
            charts: [],
            chart_source: '',
            countrys_oculto: [],
            nivelMax: 9,
            template: 'benchmarksTemplate'
          },
          literal: 'rent-top-25-municipalities'
        }
      ]
    },
    selectedReportsOptions: {
      get() {
        return this.$store.state['reports'].selectedReportsOptions
      },
      set(value) {
        this.$store.dispatch('reports/setSelectedReportsOptions', { value: value })
      }
    },
    reportZoom: {
      get() {
        return this.$store.state['reports'].reportZoom
      },
      set(value) {
        this.$store.dispatch('reports/setReportZoom', { value: value })
      }
    },
    countryName() {
      if (this.geolevels.length === 0) return 'España'
      return this.geolevels.filter((item) => item.level === 0)[0].name
    }
  },
  watch: {
    countryName() {
      // Se filtran los reports de cada pais
      this.selectedReports = this.selectedReports.filter(item => { return this.checkCountryVisibility(item.countrys_oculto) })
    },
    selectedReports() {
      this.selectedReportsOptions = this.selectedReports
      if (this.selectedReports.length > 0) {
        this.$emit('algunReportSeleccionado', true)
      } else {
        this.$emit('algunReportSeleccionado', false)
      }
    },
    geolevelselected() {
      this.getChartSource('liquidity')
      this.getChartSource('sales_price')

      switch (this.geolevelselected.level) {
        // Country
        case 0:
          this.reportZoom = 5
          break
        // Region
        case 1:
          this.reportZoom = 7
          break
        // Provincia
        case 2:
          this.reportZoom = 10
          break
        // Municipality
        case 3:
          this.reportZoom = 11
          break
        case 4:
          this.reportZoom = 13
          break
        // Census District
        case 5:
          // this.reportZoom = 11
          this.reportZoom = 13
          break
        // Neighborhood
        case 6:
          this.reportZoom = 13
          break
        // Census
        case 7:
          this.reportZoom = 13
          break
        // Zip code
        case 8:
          this.reportZoom = 14
          break
        default:
          this.reportZoom = 14
          break
      }
    }
  },
  methods: {
    checkCountryVisibility(countrys_oculto) {
      if (countrys_oculto.includes(this.countryName)) {
        return false
      } else {
        return true
      }
    },
    restartReports() {
      this.selectedReports = []
    },
    getChartSource(report_id) {
      if (this.geolevelselected === null) return
      var final_value_return = ''
      switch (report_id) {
        case 'liquidity':
          // Fuentes para Italia
          if (this.countryName === 'Italia' && this.geolevelselected.level <= 3) {
            final_value_return = 'Brainsre; Agenzia delle Entrate - Territorio - Osservatorio del mercato immobiliare'
          } else if (this.countryName === 'Italia' && this.geolevelselected.level >= 4) {
            final_value_return = 'Brainsre'
          }
          break
        case 'sales_price':
          // Fuentes para Italia
          if (this.countryName === 'Italia' && this.geolevelselected.level <= 3) {
            final_value_return = 'Brainsre; Agenzia delle Entrate - Territorio - Osservatorio del mercato immobiliare'
          } else if (this.countryName === 'Italia' && this.geolevelselected.level >= 4) {
            final_value_return = 'Brainsre'
          }
          break
        default:
          break
      }

      this.reportOptions.filter((item) => { return item.label.id === report_id })[0].label.chart_source = final_value_return
    }
  }
}
</script>

<style lang="scss" scoped>
.reportselectorcontainer {
  display: inline;
}
.container-report-type-selector {
  padding-right: 15px;
  padding-left: 10px;
  padding-top: 10px;
}

.container-checks {
  .row-check {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .no-strong {
      font-weight: 400;
    }
  }
  .checkbox-reverse {
    flex-direction: row-reverse;
  }

  .checkbox-allsqm {
    justify-content: flex-end;
    gap: 10px;
    font-weight: 600;
  }
}
</style>
